const getInitialCartOpen = () => {
  try {
    const storedCart = localStorage.getItem("cart");
    const parsed = storedCart ? JSON.parse(storedCart) : [];
    return Array.isArray(parsed) && parsed.length > 0;
  } catch (error) {
    return false;
  }
};

const initialState = {
  cartOpen: getInitialCartOpen(),
};

const ui = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_CART":
      return { ...state, cartOpen: true };
    case "CLOSE_CART":
      return { ...state, cartOpen: false };
    case "TOGGLE_CART":
      return { ...state, cartOpen: !state.cartOpen };
    default:
      return state;
  }
};

export default ui;
